<div class="viewer">
  <ngx-doc-viewer *ngIf="documentType == 'doc' ||
      documentType == 'txt' ||
      documentType == 'docx' ||
      documentType == 'ppt' ||
      documentType == 'pptx' ||
      documentType == 'xlsx' ||
      documentType == 'csv' ||
      documentType == 'xls'" 
      [url]="documentpath"
      viewer="google"
      width="100%"
      height="100%">
  </ngx-doc-viewer>

  <ngx-doc-viewer
     *ngIf="documentType == 'pdf'"
      [url]="documentpath"
      viewer="url"
      width="100%"
      height="100%">
  </ngx-doc-viewer>

  <div class="imgPreviewerDoc"
  *ngIf="documentType == 'jpeg' ||
  documentType == 'jpg' ||
  documentType == 'png' ||
  documentType == 'gif' ||
  documentType == 'gif'"
  > 
  <img src="{{documentpath}}" >

  </div>
  <div class="imgPreviewerDoc"
  *ngIf="documentType == 'heic'"> 
  <img src="{{selectedImagetoShow}}" > 
  </div>

</div>


<div class="progress-loader" *ngIf="spinner">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>

